<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-header">
        <h2 class="modal-title fs-5">
            {{
                'savedexport_export_modal_title'
                    | translate: 'online' : 'export' : [savedExport().name]
            }}
        </h2>
        <button
            type="button"
            class="btn-close"
            [attr.aria-label]="'savedexport_export_modal_close' | translate: 'online' : 'export'"
            (click)="activeModal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <app-input-date-group
            [label]="'savedexport_export_modal_reading_date_label' | translate: 'online' : 'export'"
            [required]="true"
            [noBottomMargin]="true"
            [maxDate]="maxDate"
            formControlName="readingDate" />
        <div class="form-text mt-2">
            @if (windowDays(); as days) {
                {{
                    'savedexport_export_modal_reading_date_hint_window'
                        | translate: 'online' : 'export' : [days]
                }}
            } @else {
                {{ 'savedexport_export_modal_reading_date_hint' | translate: 'online' : 'export' }}
            }
        </div>
        <div class="alert alert-web-blue mt-3 mb-0">
            {{ 'savedexport_export_modal_duration_notice' | translate: 'online' : 'export' }}
        </div>
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-outline-primary"
            [disabled]="isExporting()"
            (click)="activeModal.dismiss()">
            {{ 'actions_cancel' | translate: 'online' : 'common' }}
        </button>
        <app-action-button
            type="submit"
            [label]="
                isExporting()
                    ? {key: 'quickexports_export_action_exporting', module: 'export'}
                    : {key: 'savedexport_export_modal_export', module: 'export'}
            "
            [busy]="isExporting()"
            [disabled]="isExporting()" />
    </div>
</form>
